import { render, staticRenderFns } from "./PointsRecord.vue?vue&type=template&id=02beca86"
import script from "./PointsRecord.vue?vue&type=script&lang=js"
export * from "./PointsRecord.vue?vue&type=script&lang=js"
import style0 from "./PointsRecord.vue?vue&type=style&index=0&id=02beca86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports